import React, { useState } from 'react';
import styled from 'styled-components';
import { render } from 'react-dom';


const Data = [
    {inputid:"sunday" , daytxt :"일" , daysubmit:"sun" },
    {inputid:"monday" , daytxt :"월", daysubmit:"mon"},
    {inputid:"tuesday" , daytxt :"화", daysubmit:"tue"},
    {inputid:"wednesday" , daytxt :"수", daysubmit:"wed"},
    {inputid:"thursday" , daytxt :"목", daysubmit:"thu"},
    {inputid:"friday" , daytxt :"금", daysubmit:"fri"},
    {inputid:"saturday" , daytxt :"토", daysubmit:"sat"},
]


export default function GroupPjChangeTerm({checkSelectItemList}) {
    return(
        <Weekchoice>
            {
                Data.map((value,index)=>{
                   return <Weektxt key={`week-day-list-item-id-${value['inputid']}`}>
                            <Daycheck 
                                onClick={(e)=>{
                                    e.target.style.backgroundColor = e.target.style.backgroundColor == "rgb(255, 207, 25)" ? "#ffefce" : "#ffcf19";
                                    checkSelectItemList(index,value.daytxt,value.daysubmit);}
                                }>
                                {value.daytxt}
                            </Daycheck>
                        </Weektxt>
                })
            }
        </Weekchoice>
    );
}


// 요일선택
const Weekchoice = styled.ul`
    display:flex;
    justify-content: space-between;
    margin-top : calc(100vw*(18/375));
    margin-bottom : calc(100vw*(15/375));
`
const Weektxt = styled.li`

`

const Dayckbox = styled.input`
    display:none;

    &:checked + label {
        background-color :  #ffcf19;
    }
`

const Daycheck = styled.label`
    display: inline-block;
    width: calc(100vw*(37/375));
    height: calc(100vw*(37/375));
    background-color: #ffefce;
    border-radius : 50%;
    text-align : center;
    line-height: calc(100vw*(35/375));
    font-size: calc(100vw*(17/375));
    font-weight: 500;
    color: #ffffff;
`
// const WeektxtChecking = styled(Weektxt)`
//     background-color: #ffcf19;
// `